import axios from 'axios'
import {API_URL} from '../../../../_metronic/helpers'
import {
  OnlineAvailability,
  OnlineDelegation,
  OnlineIdentifyResult,
  OnlineMemoryResult,
  OnlineSession,
  OnlineVerifyResult,
} from './onlineRegistration'

const BASE = `${API_URL}/taxpayers/registration/online`

// The organisation answers slowly at times (nonce, then the call); the backend bounds its own waits.
const TIMEOUT = 120000

/** A step taken through a partner's sign-up link names the link, so the partner hears of the panel. */
const withPartner = (partnerSessionId?: string) => (partnerSessionId ? {partnerSessionId} : {})

export const getOnlineAvailability = async (): Promise<OnlineAvailability> => {
  const response = await axios.get(`${BASE}/availability`, {timeout: 30000})
  return response.data.data as OnlineAvailability
}

/** An empty identifier lists the files of the کارپوشه sign-in identity. */
export const identifyTaxFiles = async (
  identifier: string,
  partnerSessionId?: string
): Promise<OnlineIdentifyResult> => {
  const response = await axios.post(
    `${BASE}/identify`,
    {identifier, ...withPartner(partnerSessionId)},
    {timeout: TIMEOUT}
  )
  return response.data.data as OnlineIdentifyResult
}

export const startOnlineRegistration = async (
  economicCode: string,
  partnerSessionId?: string
): Promise<OnlineSession> => {
  const response = await axios.post(
    `${BASE}/start`,
    {economicCode, ...withPartner(partnerSessionId)},
    {timeout: TIMEOUT}
  )
  return response.data.data as OnlineSession
}

export const requestOwnerCode = async (
  inquiryId: string,
  partnerSessionId?: string
): Promise<OnlineDelegation> => {
  const response = await axios.post(
    `${BASE}/otp`,
    {inquiryId, ...withPartner(partnerSessionId)},
    {timeout: TIMEOUT}
  )
  return response.data.data as OnlineDelegation
}

export const verifyOwnerCode = async (
  inquiryId: string,
  otp: string,
  idempotencyKey: string,
  partnerSessionId?: string
): Promise<OnlineVerifyResult> => {
  const response = await axios.post(
    `${BASE}/verify`,
    {inquiryId, otp, idempotencyKey, ...withPartner(partnerSessionId)},
    {timeout: TIMEOUT}
  )
  return response.data.data as OnlineVerifyResult
}

export const issueMemoryUniqueId = async (
  companyId: number,
  partnerSessionId?: string
): Promise<OnlineMemoryResult> => {
  const response = await axios.post(
    `${BASE}/memory-unique-id`,
    {companyId, ...withPartner(partnerSessionId)},
    {timeout: TIMEOUT}
  )
  return response.data.data as OnlineMemoryResult
}

export const addExistingFiscalMemory = async (
  companyId: number,
  fiscalId: string,
  partnerSessionId?: string
): Promise<OnlineMemoryResult> => {
  const response = await axios.post(
    `${BASE}/fiscal-memory`,
    {companyId, fiscalId, ...withPartner(partnerSessionId)},
    {timeout: TIMEOUT}
  )
  return response.data.data as OnlineMemoryResult
}
